export default "__VITE_ASSET__B1mOdW4z__"